document.addEventListener('DOMContentLoaded', () => {

    const cards = document.querySelectorAll('.package-card');
    const buyButton = document.querySelector('.hero-buy-button');
    const variantInput = document.getElementById('selected-variant-id');

    const realVariantInput = document.querySelector('product-form input[name="id"]');
    const realSubmit = document.querySelector('product-form button[type="submit"]');

    cards.forEach(card => {

        card.addEventListener('click', () => {

            cards.forEach(c => c.classList.remove('active'));

            card.classList.add('active');

            variantInput.value = card.dataset.variantId;

            if (realVariantInput) {
                realVariantInput.value = card.dataset.variantId;
            }

        });

    });

    const finalBuyButton = document.querySelector('.premium-final-button');
    // ===== Trust slider induljon középen =====

const trustSlider = document.querySelector('.trust-grid');

if (trustSlider) {

    requestAnimationFrame(() => {

        trustSlider.scrollLeft =
            (trustSlider.scrollWidth - trustSlider.clientWidth) / 2;

    });

}

function addSelectedVariantToCart() {

    if (realVariantInput) {
        realVariantInput.value = variantInput.value;
    }

    if (realSubmit) {
        realSubmit.click();
    }

}

if (buyButton) {
    buyButton.addEventListener('click', addSelectedVariantToCart);
}

if (finalBuyButton) {
    finalBuyButton.addEventListener('click', addSelectedVariantToCart);
}

});